import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FinancialInventoryService} from '../_services/financial-inventory.service';
import {InventoryDataProvider} from '../_classes/inventory-datatable.class';
import {ColumnFilter, DatatableComponent, DataTableDataSource, TableAction} from '@cas-hub/acabim-common-client';
import {FinancialInventoryTable, LineItem} from '../_models/financial-inventory.model';
import {map, tap} from 'rxjs/operators';
import {flatMap} from 'rxjs/internal/operators';
import {FinancialManagementService} from '../_services/financial-management.service';
import {Subscription} from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'acabim-admin-financial-inventory',
  templateUrl: './financial-inventory.component.html',
  styleUrls: ['./financial-inventory.component.scss']
})
export class FinancialInventoryComponent implements OnInit, OnDestroy {

    @ViewChild('dataTable') public dataTable!: DatatableComponent;
    public dataSources: DataTableDataSource<any>[] = [];
    financialServiceSub: Subscription = new Subscription();
    totalRecords = 0;
    columnFilters: ColumnFilter[] = [];
    showAddInventoryModal = false;
    showEditInventoryModal = false;
    loading = false;
    financeEnabled = false;

  constructor(
      private readonly router: Router,
      private readonly financialService: FinancialManagementService,
      private readonly financialInventoryService: FinancialInventoryService
  ) { }

  ngOnInit(): void {
      this.loading = true;
      this.financialServiceSub = this.financialService.getCurrentSettings().subscribe(data => {
          if(data) {
              console.dir(data);
              if(data.enabled && data.enabled > 0) {
                  this.financeEnabled = true;
                  this.loadDatatable();
              }
              this.loading = false;
          }
      });

  }

  ngOnDestroy(): void {
      this.financialServiceSub.unsubscribe();
  }

    loadDatatable(): void {
    this.dataSources.push(
        new InventoryDataProvider(
            true,
            this.columnFilters,
            [],
            (first, length, sortOrder, sortField, filters) => {
                return this.financialInventoryService.getInventory(first, length, sortOrder, sortField = 'code', filters)
                    .pipe(
                        tap(data => this.totalRecords = data.totalRecords),
                        // tap(data => console.dir(data)),
                        flatMap(async (result) => this.getInventoryTable(result.data)),
                        map(data => ({
                          totalRecords: this.totalRecords,
                          data: (data as FinancialInventoryTable[])
                        }))
                    );
            },
            (tableName: string, error: Error) => {
              console.log('Error in retrieving data in table ', tableName);
            },
            (tableName: string) => {
            }, (action: TableAction) => {
              if (action.id === 0) {
                // this.delete = true;
              }
            }, 'All'
        )
    );
  }

    getInventoryTable(data: LineItem[]):  FinancialInventoryTable[] {
        const final: FinancialInventoryTable[] = [];
        data.forEach((d) => {
            const li: FinancialInventoryTable = {
                id: d.id,
                name: d.name,
                code: d.code,
                cost: d.default_cost,
                price: d.default_price,
                account: d.default_account.full_identifier
            };
            final.push(li);
        });
        return final;
    }

    handleDataSource(event: any): void {
      console.log(event);
      this.showEditInventoryModal = true;
    }
    openAddItemModal(): void {
        console.log('Opening add modal');
        this.showAddInventoryModal = true;
    }

    closeAddItemModal(close: boolean): void {
        console.dir(close);
        if(close) {
            this.dataTable?.requestImmediateDataRefresh();
        }
        this.showAddInventoryModal = false;
    }

    closeEditItemModal(close: boolean): void {
        console.dir(close);
        if(close) {
            this.dataTable?.requestImmediateDataRefresh();
        }
        this.showEditInventoryModal = false;
    }

    closeAddModal(close: boolean): void {
        console.dir(close);
        if(!this.dataSources[0].detailData) {
            console.dir('Changing Add');
            this.showAddInventoryModal = close;
        }
    }

    closeEditModal(close: boolean): void {
        console.dir(close);
        if(this.dataSources[0].detailData) {
            console.dir('Changing Edit');
            this.showEditInventoryModal = close;
        }
    }

    goToFinSettings(): void {
      const gotTo = '/admin/financial/settings';
      this.router.navigate([gotTo]);
    }
}
